<template>
  <div class="wrapper">
    <div class="tab white_box">
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="参保人数" name="first">
          <div class="filter">
            <el-select
              class="custom-os"
              v-model="cycle"
              @change="changeCycle"
              filterable
              default-first-option
              size="medium"
              placeholder="请选择统计周期"
            >
              <el-option
                v-for="item in cycleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-date-picker
              class="custom-zone"
              v-model="during"
              @change="changeHandle1_3"
              :picker-options="pickerOptions"
              type="monthrange"
              align="center"
              unlink-panels
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
          <div class="h_padding48 content">
            <div class="line_box box">
              <div id="bar1"></div>
              <div class="download">
                <a class="download_pic" @click="downloadPicture('bar1', '参保人数统计图')">保存图片</a>
                
              </div>
            </div>
            <div class="legends">
              <div class="legend-item row">
                <span class="point" style="background: #f26828;"></span>
                <p class="font_14_gray legend-name">参保总人数</p>
                <div class="row">
                  <p class="font_24_black">{{(detailData.insuredCount)}}</p>
                </div>
              </div>
              <div class="legend-item row">
                <span class="point" style="background: #f26828;"></span>
                <p class="font_14_gray legend-name">参保率</p>
                <div class="row">
                  <p
                    class="font_24_black"
                  >{{totalNumber > 0 ? percent(((detailData.insuredCount ) / totalNumber).toFixed(4)) : '0%'}}</p>
                </div>
              </div>
              <div class="legend-item row">
                <span class="point" style="background: #5c74f5;"></span>
                <p class="font_14_gray legend-name">社保缴纳人数</p>
                <div class="row">
                  <p class="font_24_black">{{detailData.soInsuredCount || 0}}</p>
                </div>
              </div>
              <div class="legend-item row">
                <span class="point" style="background: #5c74f5;"></span>
                <p class="font_14_gray legend-name">社保参保率</p>
                <div class="row">
                  <p 
                    class="font_24_black"
                  >{{totalNumber > 0 ? percent(((detailData.soInsuredCount || 0) / totalNumber).toFixed(4)) : '0%'}}</p>
                </div>
              </div>
              <div class="legend-item row">
                <span class="point" style="background: #85cf96;"></span>
                <p class="font_14_gray legend-name">公积金缴纳人数</p>
                <div class="row">
                  <p class="font_24_black">{{detailData.gjjInsuredCount || 0}}</p>
                </div>
              </div>
              <div class="legend-item row">
                <span class="point" style="background: #85cf96;"></span>
                <p class="font_14_gray legend-name">公积金参保率</p>
                <div class="row">
                  <p 
                    class="font_24_black" 
                  >{{totalNumber > 0 ? percent(((detailData.gjjInsuredCount || 0) / totalNumber).toFixed(4)) : '0%'}}</p>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="参保城市" name="second">
          <div class="filter">
            <el-select
              class="custom-os"
              v-model="selectedCitys"
              @change="getCityData"
              clearable
              filterable
              allow-create
              default-first-option
              multiple
              size="medium"
              placeholder="请选择参保城市"
            >
              <el-option
                v-for="item in cityOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="h_padding48 content">
            <div class="line_box box map-box">
              <div id="map"></div>
              <div class="map-legends">
                <sum title="参保人数" :num="cityTotal" num_up>
                  <img class="icon" src="@/assets/icons/Incumbency@2x.png" alt />
                </sum>
                <sum title="社保缴纳人数" :num="citySocialTotal" num_up>
                  <img class="icon" src="@/assets/icons/Payrollthismonth@2x.png" alt />
                </sum>
                <sum title="公积金缴纳人数" :num="cityGJJTotal" num_up>
                  <img class="icon" src="@/assets/icons/Providentfundinsurance@2x.png" alt />
                </sum>
              </div>
              <div class="download">
                <a class="download_pic" @click="downloadPicture('map', '参保城市统计图')">保存图片</a>
                
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="参保费用" name="third">
          <div class="filter">
            <el-select
              class="custom-os"
              v-model="cycle3"
              @change="changeCycle2"
              filterable
              default-first-option
              size="medium"
              placeholder="请选择统计周期"
            >
              <el-option
                v-for="item in cycleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-date-picker
              class="custom-zone"
              v-model="during2"
              @change="changeHandle3_3"
              :picker-options="pickerOptions3"
              type="monthrange"
              align="center"
              unlink-panels
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
          <!-- 标签筛选 -->
          <div class="tags white_box">
            <div class="tag-group row">
              <p class="font_14_black">请选择费用类别：</p>
              <filter-tag
                :class="{active: status['企业社保缴纳费用']}"
                @click.native="changeStatus('status', '企业社保缴纳费用')"
                name="企业社保缴纳费用"
              />
              <filter-tag
                :class="{active: status['员工社保缴纳费用']}"
                @click.native="changeStatus('status', '员工社保缴纳费用')"
                name="员工社保缴纳费用"
              />
              <filter-tag
                :class="{active: status['企业公积金缴纳费用']}"
                @click.native="changeStatus('status', '企业公积金缴纳费用')"
                name="企业公积金缴纳费用"
              />
              <filter-tag
                :class="{active: status['员工公积金缴纳费用']}"
                @click.native="changeStatus('status', '员工公积金缴纳费用')"
                name="员工公积金缴纳费用"
              />
            </div>
          </div>
          <div class="line-session white_box">
            <div class="h_padding48 row">
              <div class="line_box box" style="width: autp">
                <div id="bar2"></div>
                <div class="download">
                  <a class="download_pic" @click="downloadPicture('bar2', '参保费用统计图')">保存图片</a>
                  
                </div>
              </div>
              <div class="legends" style="padding-top: 0">
                <div class="legend-item row">
                  <span class="point" style="background: #f26828;"></span>
                  <p class="font_14_gray legend-name">企业社保缴纳费用</p>
                  <div class="row">
                    <p class="font_24_black">{{bar2_detail.enterpriseSocialSecurityFee}}</p>
                  </div>
                </div>
                <div class="legend-item row">
                  <span class="point" style="background: #5c74f5;"></span>
                  <p class="font_14_gray legend-name">员工社保缴纳费用</p>
                  <div class="row">
                    <p class="font_24_black">{{bar2_detail.employeeSocialSecurityFee}}</p>
                  </div>
                </div>
                <div class="legend-item row">
                  <span class="point" style="background: #85cf96;"></span>
                  <p class="font_14_gray legend-name">企业公积金缴纳费用</p>
                  <div class="row">
                    <p class="font_24_black">{{bar2_detail.enterpriseHousingFundFee}}</p>
                  </div>
                </div>
                <div class="legend-item row">
                  <span class="point" style="background: #ffb74a;"></span>
                  <p class="font_14_gray legend-name">员工公积金缴纳费用</p>
                  <div class="row">
                    <p class="font_24_black">{{bar2_detail.employeeHousingFundFee}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="pie-group white_box">
            <div class="box mb50">
              <div id="pie1"></div>
              <div class="download">
                <a class="download_pic" @click="downloadPicture('pie1', '社保、公积金参保总费用')">保存图片</a>
                
              </div>
            </div>
            <div class="box mb50">
              <div id="pie2"></div>
              <div class="download">
                <a class="download_pic" @click="downloadPicture('pie2', '企业、员工参保总费用')">保存图片</a>
                
              </div>
            </div>
            <div class="box">
              <div id="pie3"></div>
              <div class="download">
                <a class="download_pic" @click="downloadPicture('pie3', '社保参保总费用')">保存图片</a>
                
              </div>
            </div>
            <div class="box">
              <div id="pie4"></div>
              <div class="download">
                <a class="download_pic" @click="downloadPicture('pie4', '公积金参保总费用')">保存图片</a>
                
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import {
  Filter,
  downloadPic,
  dateConvert,
  Bar,
  Pie,
  MAP,
  zoneCheck,
  moneyFormat,
  toPercent
} from "@/js/tool.js";
import { Get, Download } from "@/js/http.js";
import { translateWidth } from "../js/tool";
import { trackEvent, EVENT_CODE } from "@/js/analytics.js";

export default {
  components: {},
  props: {},
  data() {
    return {
      activeTab: "first", // 当前选择的选项卡
      customerShortName: '', // 客户简称，用于水印
      options: [], // 组织搜索框选项
      selectedValue: "", // 参保人数 选择的组织id
      selectedValue2: "", // 参保城市 选择的组织id
      selectedValue3: "", // 参保费用 选择的组织id
     cycle: 0, // 周期 (0-月度、1-季度、2-年度)
      cycle3:0, // 参保费用 周期
      // 周期可选
      cycleOptions: [
        {
          value: 0,
          label: "月度"
        },
        {
          value: 1,
          label: "季度"
        },
        {
          value: 2,
          label: "年度"
        }
      ],
      during: [], // 参保人数时间区间，array或null，包含开始时间和结束时间的Date对象
      during2: [], // 参保费用时间区间，array或null，包含开始时间和结束时间的Date对象
      city: "", // 城市
      cityOptions: [], // 城市可选
      provinces: [], // 加填充色的省份
      chinaMap: {}, // 地图实例
      mapData: {}, // 地图数据
      mapDataOfCity: {}, // 选中城市的地图数据

      zoneObj: {}, // 时间区间已选的时间点
      // 日期选择器高级选项 参保人数标签页
      pickerOptions: {
        // 禁用机制
        disabledDate: time => {
          if (this.cycle === 0) {
            // 月度不限制
            return false;
          } else {
            let type = this.cycle === 2 ? "year" : "quarter";
            if (!this.zoneObj.maxDate && this.zoneObj.minDate) {
              // 该组件默认第一个选中的为minDate
              return !zoneCheck(time, {
                type,
                length: 12,
                selected: this.zoneObj.minDate
              });
            } else {
              // zoneObj中未选或已选2个
              return !zoneCheck(time, { type });
            }
          }
        },
        // 点击机制
        onPick: zoneObj => {
          this.zoneObj = zoneObj;
        }
      },
      // 日期选择器高级选项 参保费用标签页
      pickerOptions3: {
        // 禁用机制
        disabledDate: time => {
          if (this.cycle3 === 0) {
            // 月度不限制
            return false;
          } else {
            let type = this.cycle3 === 2 ? "year" : "quarter";
            if (!this.zoneObj.maxDate && this.zoneObj.minDate) {
              // 该组件默认第一个选中的为minDate
              return !zoneCheck(time, {
                type,
                selected: this.zoneObj.minDate
              });
            } else {
              return !zoneCheck(time, { type });
            }
          }
        },
        // 点击机制
        onPick: zoneObj => {
          this.zoneObj = zoneObj;
        }
      },
      // 筛选按钮
      status: {
        企业社保缴纳费用: true,
        员工社保缴纳费用: true,
        企业公积金缴纳费用: true,
        员工公积金缴纳费用: true
      },

      bar2: {}, // 参保费用柱状图实例
      // 参保人数柱状图数据
      barData: {
        xArray: [],
        legend: [],
        valueData: [[], [], []]
      },
      detailData: {}, // 参保人数右侧数据
      sourceData1: [], // 参保人数源数据
      totalNumber: 0, // 在职员工总数

      cityTotal: 0,
      citySocialTotal: 0,
      cityGJJTotal: 0,

      // 参保费用柱状图数据
      bar2_source: [],
      bar2_detail: {},
      barData2: undefined,
      // 参保费用饼图数据
      data1: [],
      data2: [],
      data3: [],
      data4: [],

      chartImgUrl: "", // 下载用的图片base64

      bar2_event: false
    };
  },
  watch: {},
  computed: {
    // 参保人数 开始时间
    EffectTimeStart() {
      if (this.during) {
        return dateConvert(this.during[0], {
          format: "Y-M"
        });
      } else {
        return "";
      }
    },
    // 参保人数 结束时间
    EffectTimeEnd() {
      if (this.during) {
        return dateConvert(this.during[1], {
          format: "Y-M"
        });
      } else {
        return "";
      }
    },
    // 参保费用 开始时间
    EffectTimeStart2() {
      if (this.during2) {
        return dateConvert(this.during2[0], {
          format: "Y-M"
        });
      } else {
        return "";
      }
    },
    // 参保费用 结束时间
    EffectTimeEnd2() {
      if (this.during2) {
        return dateConvert(this.during2[1], {
          format: "Y-M"
        });
      } else {
        return "";
      }
    }
  },
  methods: {
    // 点击标签页
    handleClick() {},
    // 参保人数更改周期
    changeCycle() {
      // 根据周期类型重置日期范围
      let current = new Date();
      let currentYear = current.getFullYear();
      let currentMonth = current.getMonth(); // 0-11
      
      let startDate, endDate;
      
      // cycleOptions: 0-月度, 1-季度, 2-年度
      switch (this.cycle) {
        case 0: { // 月度
          // 最近半年：当前月往前推5个月
          startDate = new Date(currentYear, currentMonth - 5, 1);
          endDate = new Date(currentYear, currentMonth + 1, 0);
          break;
        }
        case 1: { // 季度
          // 本季度：按照用户要求的季度划分，显示完整季度
          let quarterStartMonth, quarterEndMonth;
          if (currentMonth >= 0 && currentMonth <= 2) { // 1-3月，第一季度
            quarterStartMonth = 0;
            quarterEndMonth = 2;
          } else if (currentMonth >= 3 && currentMonth <= 5) { // 4-6月，第二季度
            quarterStartMonth = 3;
            quarterEndMonth = 5;
          } else if (currentMonth >= 6 && currentMonth <= 9) { // 7-10月，第三季度
            quarterStartMonth = 6;
            quarterEndMonth = 9;
          } else { // 11-12月，第四季度
            quarterStartMonth = 11;
            quarterEndMonth = 11;
          }
          startDate = new Date(currentYear, quarterStartMonth, 1);
          endDate = new Date(currentYear, quarterEndMonth + 1, 0);
          break;
        }
        case 2: { // 年度
          // 本年：从1月1日到12月31日
          startDate = new Date(currentYear, 0, 1);
          endDate = new Date(currentYear, 11, 31);
          break;
        }
      }
      
      this.during = [startDate, endDate];
      this.getNumberData();
    },
    changeCycle2() {
      // 根据周期类型重置日期范围
      let current = new Date();
      let currentYear = current.getFullYear();
      let currentMonth = current.getMonth(); // 0-11
      
      let startDate, endDate;
      
      // cycleOptions: 0-月度, 1-季度, 2-年度
      switch (this.cycle3) {
        case 0: { // 月度
          // 最近半年：当前月往前推5个月
          startDate = new Date(currentYear, currentMonth - 5, 1);
          endDate = new Date(currentYear, currentMonth + 1, 0);
          break;
        }
        case 1: { // 季度
          // 本季度：按照用户要求的季度划分，显示完整季度
          let quarterStartMonth, quarterEndMonth;
          if (currentMonth >= 0 && currentMonth <= 2) { // 1-3月，第一季度
            quarterStartMonth = 0;
            quarterEndMonth = 2;
          } else if (currentMonth >= 3 && currentMonth <= 5) { // 4-6月，第二季度
            quarterStartMonth = 3;
            quarterEndMonth = 5;
          } else if (currentMonth >= 6 && currentMonth <= 9) { // 7-10月，第三季度
            quarterStartMonth = 6;
            quarterEndMonth = 9;
          } else { // 11-12月，第四季度
            quarterStartMonth = 11;
            quarterEndMonth = 11;
          }
          startDate = new Date(currentYear, quarterStartMonth, 1);
          endDate = new Date(currentYear, quarterEndMonth + 1, 0);
          break;
        }
        case 2: { // 年度
          // 本年：从1月1日到12月31日
          startDate = new Date(currentYear, 0, 1);
          endDate = new Date(currentYear, 11, 31);
          break;
        }
      }
      
      // 使用$nextTick确保during2正确更新后再刷新数据
      this.$nextTick(() => {
        this.during2 = [startDate, endDate];
        this.getAmountBarData();
      });
    },
    // 参保费用更改周期
    percent(num) {
      return toPercent(num, 2);
    },
    // 修改时间区间
    changeHandle1_3() {
      this.zoneObj = {}; // 可省略
      this.getNumberData();
    },
    changeHandle3_3() {
      this.zoneObj = {}; // 可省略
      this.getAmountData();
    },
    // 修改筛选标签
    changeStatus(dataName, key) {
      let ischanged = Filter.call(this, dataName, key);
      if (ischanged) {
        this.bar2.dispatchAction({
          type: "legendToggleSelect",
          name: key
        });
        // this.getAmountBarData();
      }
    },
    // 获取选项
    getOptions() {
      // 组织选项
      Get("api/v1/customers/selectors").then(({ data }) => {
        this.options = data;
      });
    },
    // 获取客户信息
    getCustomerInfo() {
      Get("api/v1.0/customers/info").then(res => {
        if (res.data && res.data.customerShortName) {
          this.customerShortName = res.data.customerShortName;
        }
      }).catch(() => {
        this.customerShortName = '武汉行舟';
      });
    },
    // 获取在职员工总数
    getTotalNumber() {
      Get("api/v1/employees/statistic", {
        // 可以根据需要添加参数
      }).then(res => {
        // 使用接口返回的 totalCount 作为参保率的分母
        this.totalNumber = res.data.hiredCount || 0;
      }).catch(error => {
        console.error('获取统计数据失败:', error);
        this.totalNumber = 0;
      });
    },
    // 获取参保人数数据
    getNumberData() {
      // 假如未选择区间
      if(!this.during) {
        return false;
      }
      this.detailData = {};
      Get("api/v1/reports/social-security/insureds", {
        ReportType: this.cycle,
        BeginMonth: this.EffectTimeStart,
        EndMonth: this.EffectTimeEnd
      }).then(res => {
        let data = res.data;
        console.log('参保人数API返回数据:', data);
        
        // 检查每个数据项是否有 periodLabel
        if (data && data.length > 0) {
          data.forEach((item, index) => {
            console.log(`第${index+1}条数据:`, item);
            console.log(`periodLabel:`, item.periodLabel);
          });
        }
        
        this.sourceData1 = data;
        
        // 使用 periodLabel 作为 X 轴数据
        let xArray = data.map(item => item.periodLabel);
        console.log('参保人数X轴数据:', xArray);
        
        let barData = {
          xArray: xArray,
          legend: ["参保总人数", "社保缴纳人数", "公积金缴纳人数"],
          valueData: [
            data.map(item => (item.insuredCount)),
            data.map(item => item.soInsuredCount),
            data.map(item => item.gjjInsuredCount)
          ]
        };
        console.log('参保人数图表配置:', barData);
        this.barData = barData;
        
        // 解析统计数据 msg: "Insured:1,SoInsured:1,GjjInsured:1"
        if (res.msg) {
          const stats = res.msg.split(',').reduce((acc, item) => {
            const [key, value] = item.split(':');
            acc[key] = parseInt(value) || 0;
            return acc;
          }, {});
          this.detailData = {
            insuredCount: stats.Insured || 0,
            soInsuredCount: stats.SoInsured || 0,
            gjjInsuredCount: stats.GjjInsured || 0
          };
        }
        
        // 销毁旧的图表实例
        if (this.bar && this.bar.dispose) {
          this.bar.dispose();
        }
        
        this.$nextTick(() => {
          this.bar = this.drawBar("bar1", barData, "参保人数统计图");
        });
      });
    },
    // 获取参保城市选项
    getCity() {
      Get("api/v1/social-securities/cities", {})
      .then(({ data }) => {
        this.cityOptions = data.map(item => item.city);
        
        // 初始化地图数据
        this.mapData = {
          legend: ["参保城市"],
          datas: [data.map(item => ({ name: item.city }))],
          style: []
        };
        
        // 获取城市参保数据
        this.getCityData();
      })
      .catch(error => {
        console.error('获取城市数据失败:', error);
      });
    },
    // 获取搜索城市数据
    getCityData() {
      trackEvent(EVENT_CODE.SOCIAL_SECURITY_DATA_CITY_SWITCH, {
        cities: this.selectedCitys || []
      });
      
      // 构建城市参数（以逗号分隔的字符串）
      let cities = '';
      if (this.selectedCitys && this.selectedCitys.length > 0) {
        // 如果选择了多个城市
        cities = this.selectedCitys.join(',');
      } else if (this.cityOptions && this.cityOptions.length > 0) {
        // 如果没有选择城市，使用所有城市选项
        cities = this.cityOptions.join(',');
      }
      
      // 传递城市参数，以逗号分隔的数组格式
      Get("api/v1/reports/social-security/insured-cities", {
        cities: cities,
        ReportType: this.cycle,
        BeginMonth: this.EffectTimeStart,
        EndMonth: this.EffectTimeEnd
      }).then(res => {
        let data = res.data || [];
        this.cityOfCustom = data;
        
        let city = this.selectedCitys && this.selectedCitys.length > 0 ? this.selectedCitys[0] : '';
        let mapData = JSON.parse(JSON.stringify(this.mapData));
        // 如果选择了城市，重绘地图
        if (city && mapData.datas && mapData.datas[0]) {
          mapData.datas[0] = mapData.datas[0].filter(item => item.name != city);
          mapData.datas.push([{ name: city }]);
          mapData.style = [
            {},
            {
              symbolSize: 50, // 增大图标大小
              label: {
                normal: {
                  formatter: "{b}",
                  position: "bottom",
                  show: true,
                  padding: [3, 7, 1, 7],
                  fontSize: 18,
                  color: "#fff",
                  backgroundColor: "rgba(100, 100, 100, 0.9)",
                  borderRadius: 10
                },
                emphasis: {
                  show: true
                }
              }
            }
          ];
          this.mapDataOfCity = mapData;
        }
        this.chinaMap.clear && this.chinaMap.clear();
        this.chinaMap = this.drawMap(
          "map",
          mapData
        );

        this.cityTotal = data.reduce((result, item) => {
          return result + (item.insuredCount || 0);
        }, 0);
        this.citySocialTotal = data.reduce((result, item) => {
          return result + (item.soInsuredCount || 0);
        }, 0);
        this.cityGJJTotal = data.reduce((result, item) => {
          return result + (item.gjjInsuredCount || 0);
        }, 0);
      });
    },
    // 获取参保费用数据
    getAmountData() {
      this.getAmountBarData();
      // this.getAmountPieData();
    },
    // 获取柱状图数据
    getAmountBarData() {
      // 假如未选择区间
      if(!this.during2) {
        return false;
      }
      // 参保费用统计柱状图
      Get("api/v1/reports/social-security/insured-costs", {
        // customerId: this.selectedValue3,
        ReportType: this.cycle3,
        BeginMonth: this.EffectTimeStart2,
        EndMonth: this.EffectTimeEnd2
      }).then(res => {
        let data = res.data;
        console.log('参保费用API返回数据:', data);
        this.bar2_source = data;
        
        // 使用 periodLabel 作为 X 轴数据
        let xArray = data.map(item => item.periodLabel);
        console.log('参保费用X轴数据:', xArray);
        
        let barData2 = {
          xArray: xArray,
          legend: [
            "企业社保缴纳费用",
            "员工社保缴纳费用",
            "企业公积金缴纳费用",
            "员工公积金缴纳费用"
          ],
          valueData: [
            data.map(item => item.enterpriseSocialSecurityFee),
            data.map(item => item.employeeSocialSecurityFee),
            data.map(item => item.enterpriseHousingFundFee),
            data.map(item => item.employeeHousingFundFee)
          ]
        };
        console.log('参保费用图表配置:', barData2);
        this.barData2 = barData2;
        
        // 销毁旧的图表实例
        if (this.bar2 && this.bar2.dispose) {
          this.bar2.dispose();
        }
        
        this.$nextTick(() => {
          this.bar2 = this.drawBar2("bar2", barData2, "参保费用统计图");
          
          // 绑定一次柱状图点击事件
          if (!this.bar2_event) {
            this.bar2.on("click", "series", p => {
              let data = this.bar2_source.find(item => {
                return item.periodLabel == p.name;
              });
              if (data) {
                this.getAmountPieData([data]);
              }
            });
            this.bar2_event = true;
          }
        });
        
        this.getAmountPieData(data);
      });
    },
    // 获取饼图数据(前台计算)data为array
    getAmountPieData(data) {
      let social_amount = 0,
        gjj_amount = 0,
        social_gjj_sum = 0,
        person_amount = 0,
        org_amount = 0,
        person_org_sum = 0,
        social_org_amount = 0,
        social_person_mount = 0,
        social_sum = 0,
        gjj_org_amount = 0,
        gjj_person_amount = 0,
        gjj_sum = 0;
      data.map(item => {
        social_amount += item.employeeSocialSecurityFee + item.enterpriseSocialSecurityFee;
        gjj_amount += item.employeeHousingFundFee + item.enterpriseHousingFundFee;

        person_amount += item.employeeHousingFundFee + item.employeeSocialSecurityFee;
        org_amount += item.enterpriseHousingFundFee + item.enterpriseSocialSecurityFee;

        social_org_amount += item.enterpriseSocialSecurityFee;
        social_person_mount += item.employeeSocialSecurityFee;

        gjj_org_amount += item.enterpriseHousingFundFee;
        gjj_person_amount += item.employeeHousingFundFee;
      });

      this.social_gjj_sum = social_gjj_sum = social_amount + gjj_amount;
      this.pieData1 = {
        type: 1,
        firstAmount: parseFloat(social_amount.toFixed(2)),
        secondAmount: parseFloat(gjj_amount.toFixed(2)),
        totalAmount: parseFloat(social_gjj_sum.toFixed(2))
      };
      this.person_org_sum = person_org_sum = person_amount + org_amount;
      this.pieData2 = {
        type: 2,
        secondAmount: parseFloat(person_amount.toFixed(2)),
        firstAmount: parseFloat(org_amount.toFixed(2)),
        totalAmount: parseFloat(person_org_sum.toFixed(2))
      };
      this.social_sum = social_sum = social_org_amount + social_person_mount;
      this.pieData3 = {
        type: 3,
        firstAmount: parseFloat(social_org_amount.toFixed(2)),
        secondAmount: parseFloat(social_person_mount.toFixed(2)),
        totalAmount: parseFloat(social_sum.toFixed(2))
      };
      this.gjj_sum = gjj_sum = gjj_org_amount + gjj_person_amount;
      this.pieData4 = {
        type: 4,
        firstAmount: parseFloat(gjj_org_amount.toFixed(2)),
        secondAmount: parseFloat(gjj_person_amount.toFixed(2)),
        totalAmount: parseFloat(gjj_sum.toFixed(2))
      };

      let pieData1 = [
        { value: parseFloat(social_amount.toFixed(2)), name: "社保费用" },
        { value: parseFloat(gjj_amount.toFixed(2)), name: "公积金费用" }
      ];
      this.pie_data1 = pieData1;
      this.pie1 = this.drawPie(
        "pie1",
        pieData1,
        "社保、公积金参保总费用合计：￥" + moneyFormat(social_gjj_sum, 2)
      );

      let pieData2 = [
        { value: parseFloat(org_amount.toFixed(2)), name: "企业费用" },
        { value: parseFloat(person_amount.toFixed(2)), name: "员工费用" }
      ];
      this.pie_data2 = pieData2;
      this.pie2 = this.drawPie(
        "pie2",
        pieData2,
        "企业、员工参保总费用合计：￥" + moneyFormat(person_org_sum, 2)
      );

      let pieData3 = [
        { value: parseFloat(social_org_amount.toFixed(2)), name: "企业费用" },
        { value: parseFloat(social_person_mount.toFixed(2)), name: "个人费用" }
      ];
      this.pie_data3 = pieData3;
      this.pie3 = this.drawPie(
        "pie3",
        pieData3,
        "社保参保总费用合计：￥" + moneyFormat(social_sum, 2)
      );

      let pieData4 = [
        { value: parseFloat(gjj_org_amount.toFixed(2)), name: "企业费用" },
        { value: parseFloat(gjj_person_amount.toFixed(2)), name: "个人费用" }
      ];
      this.pie_data4 = pieData4;
      this.pie4 = this.drawPie(
        "pie4",
        pieData4,
        "公积金参保总费用合计：￥" + moneyFormat(gjj_sum, 2)
      );
    },
    // 下载图片
    downloadPicture(id, title) {
      downloadPic(id, title, this.customerShortName);
    },
    // 下载参保人数统计excel
    downData1() {
      Download(
        "/api/v1/reports/social-security/insureds/excel",
        {
          // customerId: this.selectedValue,
          ReportType: this.cycle,
          BeginMonth: this.EffectTimeStart,
          EndMonth: this.EffectTimeEnd
        },
        "参保人数统计.xlsx"
      );
    },
    // 下载参保城市统计excel
    downData2() {
      let cities = this.selectedCitys && this.selectedCitys.length > 0 
        ? this.selectedCitys.join(',') 
        : this.cityOptions.join(',');
      Download(
        "api/v1/reports/social-security/insured-cities/excel",
        {
          cities: cities
        },
        "参保城市统计.xlsx"
      );
    },
    // 下载参保费用柱状图数据excel
    downData3() {
      Download(
        "/api/v1/reports/social-security/insured-costs/excel",
        {
          // customerId: this.selectedValue,
          section: 1,
          ReportType: this.cycle3,
          BeginMonth: this.EffectTimeStart2,
          EndMonth: this.EffectTimeEnd2
        },
        "参保费用统计.xlsx"
      );
    },
    // 下载饼图数据excel
    downData4(data, title, section) {
      Download("/api/v1/reports/social-security/insured-costs/excel",   {
          // customerId: this.selectedValue,
          section: section,
          ReportType: this.cycle3,
          BeginMonth: this.EffectTimeStart2,
          EndMonth: this.EffectTimeEnd2
        },
        title);
    },
    // 绘制柱状图1 - 参保人数
    drawBar(id, data, title) {
      return Bar.call(this, id, data, {
        title: title,
        watermarkText: this.customerShortName,
        option: {
          // X 轴配置
          xAxis: [
            {
              type: "category",
              offset: 16,
              axisTick: {
                show: true,
                alignWithLabel: true,
                lineStyle: {
                  color: "#b8bac9"
                }
              },
              axisLine: {
                lineStyle: {
                  opacity: 0 // 不显示轴线
                }
              },
              axisLabel: {
                color: "#b8bac9", // 刻度标签样式
                rotate: data.xArray && data.xArray.length > 6 ? 45 : 0, // 标签太多时旋转
                interval: 0 // 强制显示所有标签
              },
              boundaryGap: false,
              data: data.xArray
            }
          ],
          // Y 轴配置
          yAxis: [
            {
              type: "value",
              offset: 16,
              axisTick: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  opacity: 0 // 不显示轴线
                }
              },
              axisLabel: {
                color: "#b8bac9" // 刻度标签样式
              }
            }
          ],
          // 网格配置
          grid: {
            left: "5%",
            right: "5%",
            bottom: "20%",
            containLabel: true
          },
          tooltip: {
            trigger: "axis",
            // 利用提示框formatter方法修改实例外变量
            formatter: p => {
              if (p instanceof Array && p.length > 0) {
                // p[0].name是x轴标签名，就是 periodLabel
                const currentLabel = p[0].name;
                
                // 查找对应的数据 - 使用 periodLabel
                const foundItem = this.sourceData1.find(
                  item => item.periodLabel === currentLabel
                );
                
                if (foundItem) {
                  this.detailData = foundItem;
                  // 显示图例数值
                  const legends = document.querySelectorAll('.legends .row');
                  legends.forEach(legend => {
                    legend.style.opacity = '1';
                  });
                }
                
                // 构建 tooltip 显示内容
                let tooltipContent = `<div style="font-weight:bold;margin-bottom:5px;">${currentLabel}</div>`;
                
                p.forEach(series => {
                  tooltipContent += `
                    <div style="display:flex;align-items:center;margin:3px 0;">
                      <span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:${series.color};margin-right:5px;"></span>
                      <span style="margin-right:10px;">${series.seriesName}:</span>
                      <span style="font-weight:bold;">${series.value}</span>
                    </div>
                  `;
                });
                
                return tooltipContent;
              }
              return '';
            },
            // 鼠标离开时清空详情数据
            leave: () => {
              this.detailData = {};
              // 隐藏图例数值
              const legends = document.querySelectorAll('.legends .row');
              legends.forEach(legend => {
                legend.style.opacity = '0';
              });
            }
          }
        }
      });
    },
    // 绘制柱状图2 - 参保费用
    drawBar2(id, data, title) {
      let colorList = ["#f26828", "#5c74f5", "#85cf96", "#ffb74a"];
      let borderRadiusList = [
        [0, 0, 25, 25],
        [25, 25, 0, 0],
        [0, 0, 25, 25],
        [25, 25, 0, 0]
      ];
      
      return Bar.call(this, id, data, {
        title: title,
        watermarkText: this.customerShortName,
        option: {
          // X 轴配置
          xAxis: [
            {
              type: "category",
              offset: 16,
              axisTick: {
                show: true,
                alignWithLabel: true,
                lineStyle: {
                  color: "#b8bac9"
                }
              },
              axisLine: {
                lineStyle: {
                  opacity: 0 // 不显示轴线
                }
              },
              axisLabel: {
                color: "#b8bac9", // 刻度标签样式
                rotate: data.xArray && data.xArray.length > 6 ? 45 : 0, // 标签太多时旋转
                interval: 0 // 强制显示所有标签
              },
              boundaryGap: false,
              data: data.xArray
            }
          ],
          // Y 轴配置
          yAxis: [
            {
              type: "value",
              offset: 16,
              axisTick: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  opacity: 0 // 不显示轴线
                }
              },
              axisLabel: {
                color: "#b8bac9" // 刻度标签样式
              }
            }
          ],
          // 网格配置
          grid: {
            left: "5%",
            right: "5%",
            bottom: "20%",
            containLabel: true
          },
          tooltip: {
            trigger: "axis",
            // 利用提示框formatter方法修改实例外变量
            formatter: p => {
              if (p instanceof Array && p.length > 0) {
                // p[0].name是x轴标签名
                const currentLabel = p[0].name;
                
                // 查找对应的数据 - 使用 periodLabel
                const foundItem = this.bar2_source.find(
                  item => item.periodLabel === currentLabel
                );
                
                if (foundItem) {
                  this.bar2_detail = foundItem;
                }
                
                // 构建 tooltip 显示内容
                let tooltipContent = `<div style="font-weight:bold;margin-bottom:5px;">${currentLabel}</div>`;
                
                p.forEach(series => {
                  const value = series.value;
                  const formattedValue = value ? '￥' + value.toLocaleString() : '￥0';
                  
                  tooltipContent += `
                    <div style="display:flex;align-items:center;margin:3px 0;">
                      <span style="display:inline-block;width:10px;height:10px;border-radius:50%;background-color:${series.color};margin-right:5px;"></span>
                      <span style="margin-right:10px;">${series.seriesName}:</span>
                      <span style="font-weight:bold;">${formattedValue}</span>
                    </div>
                  `;
                });
                
                return tooltipContent;
              }
              return '';
            }
          },
          legend: {
            data: data.legend,
            bottom: 0,
            icon: "circle",
            itemGap: translateWidth(20),
            itemWidth: translateWidth(8),
            itemHeight: translateWidth(8)
          },
          series: data.valueData.map((item, key) => {
            let stackName;
            let legendName = data.legend[key];
            if (
              legendName === "企业社保缴纳费用" ||
              legendName === "员工社保缴纳费用"
            ) {
              stackName = "left";
            } else {
              stackName = "right";
            }
            return {
              name: legendName,
              type: "bar",
              stack: stackName,
              barWidth: translateWidth(10),
              itemStyle: {
                color: colorList[key],
                barBorderRadius: borderRadiusList[key]
              },
              data: item
            };
          })
        }
      });
    },
    // 绘制饼图
    drawPie(id, data, title) {
      return Pie.call(this, id, data, {
        title: title,
        watermarkText: this.customerShortName,
        option: {
          legend: {
            orient: "vertical",
            align: "left",
            // x: "right",
            y: "middle",
            // top: "20%",
            right: "6%",
            icon: "circle",
            itemWidth: translateWidth(8),
            itemHeight: translateWidth(8),
            itemGap: translateWidth(20),
            data: data.map(item => item.name),
            formatter: function(name) {
              let value;
              let per;
              let total = 0;
              for (let i = 0; i < data.length; i++) {
                total += data[i].value;
              }
              for (let i = 0; i < data.length; i++) {
                if (data[i].name === name) {
                  value = data[i].value;
                  per =
                    toPercent(value / total, 0) === 0
                      ? "0%"
                      : toPercent(value / total, 0);
                }
              }
              return (
                "{a|" + name + "}{c|￥}{b|" + value + "}" + "{d|" + per + "}"
              );
            },
            textStyle: {
              rich: {
                a: {
                  width: 60,
                  fontSize: translateWidth(14, "font"),
                  color: "#949494",
                  padding: translateWidth([10, 10, 10, 4])
                },
                b: {
                  padding: translateWidth([0, 10, 0, 0]),
                  fontSize: translateWidth(24, "font"),
                  color: "#000",
                  height: translateWidth(28),
                  verticalAlign: "top",
                  shadowColor: "#b00",
                  shadowBlur: translateWidth(10),
                  shadowOffsetX: translateWidth(20),
                  shadowOffsetY: translateWidth(10)
                },
                d: {
                  fontSize: translateWidth(14, "font"),
                  color: "#949494"
                }
              }
            }
          }
        }
      });
    },
    // 绘制地图
    drawMap(id, data) {
      const mapInstance = MAP.call(this, id, data, {
        title: "参保城市统计图",
        watermarkText: this.customerShortName,
        option: {
          geo: {
            map: "china", // 地图注册时的名称
            top: translateWidth(260),
            zoom: 1.4, // 缩放
            label: {
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                areaColor: "#f3f3f3", // 填充色
                borderColor: "#fff", // 边框色
                borderWidth: 1.4
              },
              emphasis: {
                areaColor: "#f3f3f3" // 高亮填充色
              }
            },
            // 特定区域样式
            regions: this.provinces.map(item => {
              return {
                name: item,
                itemStyle: {
                  areaColor: "#5c74f5"
                }
              };
            }),
            silent: false
          },
          tooltip: {
            show: true,
            trigger: "item",
            formatter: p => {
              let detailData = this.cityOfCustom.find(
                item => item.city === p.name
              );
              if (detailData) {
                this.cityTotal = detailData.totalCount || detailData.insuredCount || 0;
                this.citySocialTotal = detailData.socialCount || detailData.soInsuredCount || 0;
                this.cityGJJTotal = detailData.gjjCount || detailData.gjjInsuredCount || 0;
              }
            }
          }
        }
      });

      // 添加地图点击事件
      mapInstance.on('click', 'geo', params => {
        const cityName = params.name;
        console.log('地图点击事件触发，城市名称:', cityName);
        console.log('城市选项列表:', this.cityOptions);
        // 检查该城市是否在城市列表中
        if (this.cityOptions.includes(cityName)) {
          console.log('城市在选项列表中，准备更新选择器');
          // 更新城市选择器（使用selectedCitys多选数组）
          if (!this.selectedCitys.includes(cityName)) {
            this.selectedCitys.push(cityName);
            console.log('已将城市添加到选择器:', this.selectedCitys);
          } else {
            console.log('城市已经在选择器中:', this.selectedCitys);
          }
          // 重新获取数据
          console.log('准备调用 getCityData()');
          this.getCityData();
        } else {
          console.log('城市不在选项列表中:', cityName);
        }
      });

      return mapInstance;
    },
    // 绑定窗口缩放事件
    ifResize() {
      window.addEventListener("resize", this.resizeCharts);
    },
    // 重新设置报表大小
    resizeCharts() {
      // 地图要清空重绘
      if (this.chinaMap) {
        this.chinaMap.resize();
        this.chinaMap.clear && this.chinaMap.clear();
        let mapData = this.selectedCitys && this.selectedCitys.length > 0 ? this.mapDataOfCity : this.mapData;
        this.chinaMap = this.drawMap("map", mapData);
      }

      // 其他echarts实例
      ["bar", "bar2", "pie1", "pie2", "pie3", "pie4"].forEach(item => {
        if (this[item]) {
          this[item].resize();
        }
      });

      if (this.barData && this.barData.xArray) {
        this.drawBar("bar1", this.barData, "参保人数统计图");
      }
      
      if (this.barData2 && this.barData2.xArray) {
        this.drawBar2("bar2", this.barData2, "参保费用统计图");
      }
      
      if (this.pie_data1) {
        this.drawPie(
          "pie1",
          this.pie_data1,
          "社保、公积金参保总费用合计：￥" + moneyFormat(this.social_gjj_sum, 2)
        );
      }
      
      if (this.pie_data2) {
        this.drawPie(
          "pie2",
          this.pie_data2,
          "企业、员工参保总费用合计：￥" + moneyFormat(this.person_org_sum, 2)
        );
      }
      
      if (this.pie_data3) {
        this.drawPie(
          "pie3",
          this.pie_data3,
          "社保参保总费用合计：￥" + moneyFormat(this.social_sum, 2)
        );
      }
      
      if (this.pie_data4) {
        this.drawPie(
          "pie4",
          this.pie_data4,
          "公积金参保总费用合计：￥" + moneyFormat(this.gjj_sum, 2)
        );
      }
    },
    
    // 调试方法
    checkDataStructure() {
      console.log('sourceData1:', this.sourceData1);
      if (this.sourceData1 && this.sourceData1.length > 0) {
        console.log('第一条数据字段:', Object.keys(this.sourceData1[0]));
        console.log('periodLabel值:', this.sourceData1[0].periodLabel);
      }
      
      console.log('bar2_source:', this.bar2_source);
      if (this.bar2_source && this.bar2_source.length > 0) {
        console.log('第一条bar2数据字段:', Object.keys(this.bar2_source[0]));
        console.log('periodLabel值:', this.bar2_source[0].periodLabel);
      }
    }
  },
  created() {},
  mounted() {
    this.getOptions();
    this.getCustomerInfo();
    this.getCity();
    this.getTotalNumber();
    this.changeCycle();
    this.changeCycle2();
    this.ifResize();
    
    // 延迟一点检查数据
    setTimeout(() => {
      this.checkDataStructure();
    }, 1000);
  },
  beforeDestroy() {
    // 解除事件
    window.removeEventListener("resize", this.resizeCharts);
    
    // 销毁图表实例
    ['bar', 'bar2', 'pie1', 'pie2', 'pie3', 'pie4', 'chinaMap'].forEach(item => {
      if (this[item] && this[item].dispose) {
        this[item].dispose();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 150px 32px 24px;
  position: relative;
  .content {
    display: flex;
    padding-bottom: 94px;
    background-color: #fff;
    overflow-x: auto;
    .legends {
      flex: 1;
      padding-top: 100px;
      padding-left: 100px;
      .legend-item {
        height: 28px;
        margin-bottom: 20px;
        .point {
          width: 8px;
          height: 8px;
          margin-right: 6px;
          border-radius: 50%;
        }
        .legend-name {
          min-width: 120px;
          margin-right: 6px;
        }
      }
    }
  }
  .filter {
    display: flex;
    padding: 22px 48px;
    background-color: #fff;
    position: fixed;
    top: 70px;
    left: 11.6vw;
    right: 32px;
    z-index: 100;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    box-sizing: border-box;
  }
  .tags {
    padding-bottom: 32px;
    margin-bottom: 32px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .tag-group {
    margin-left: 50px;
  }
  .line-session {
    padding-top: 32px;
    padding-bottom: 32px;
    margin-bottom: 32px;
  }
  .line_box {
    width: 898px;
    height: 590px;
    padding: 50px 80px 30px;
    box-shadow: 0px 4px 8px 0px rgba(55, 14, 14, 0.08),
      0px -4px 8px 0px rgba(55, 14, 14, 0.08);
    border-radius: 10px;
    // background:url('../assets/bj.png');
    &.map-box {
      display: flex;
      height: 1080px;
      .map-legends {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-self: center;
        width: 22%;
        height: 40%;
        margin-left: 80px;
        padding: 76px 0 76px 72px;
        background-color: #f8f8f8;
        box-shadow: 0px 4px 8px 0px rgba(55, 14, 14, 0.08),
          0px -4px 8px 0px rgba(55, 14, 14, 0.08);
        border-radius: 10px;
      }
    }
  }
  .pie-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 32px 50px 32px;
    > div {
      overflow: hidden;
      box-shadow: 0px 4px 8px 0px rgba(55, 14, 14, 0.08),
        0px -4px 8px 0px rgba(55, 14, 14, 0.08);
      border-radius: 10px;
    }
  }
}
.legends {
  flex: 1;
  padding-top: 100px;
  padding-left: 100px;
  .legend-item {
    height: 28px;
    margin-bottom: 20px;
    .point {
      width: 8px;
      height: 8px;
      margin-right: 6px;
      border-radius: 50%;
    }
    .legend-name {
      min-width: 150px;
      margin-right: 6px;
    }
    .row {
      opacity: 0;
      transition: opacity 0.3s ease;
    }
  }
}
// 选项卡
.el-tabs {
  ::v-deep .el-tabs__nav .el-tabs__item {
    padding: 0 49px;
    height: 64px;
    font-size: 16px;
    line-height: 64px;
    &.is-active {
      color: #f26828;
    }
    &:hover {
      color: #f26828;
    }
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #f26828;
  }
  ::v-deep .el-tabs__content {
    background-color: #efeff3;
  }
}

.box {
  position: relative;
  &.mb50 {
    margin-bottom: 50px;
  }
  .download {
    position: absolute;
    left: 0;
    bottom: 45px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .download_pic {
    display: inline-block;
    padding: 8px 16px;
    margin-right: 30px;
    background-color: #fff;
    border: 1px solid #f78536;
    border-radius: 4px;
    font-size: 14px;
    color: #f78536;
    text-decoration: none;
    cursor: pointer;
    &:hover {
      background-color: #fff8f5;
      border-color: #f78536;
    }
    &:active {
      background-color: #ffe8d9;
      border-color: #f78536;
    }
  }
  .download_data {
    &:active {
      background-color: rgba(100, 100, 100, 0.1);
    }
    img {
      display: block;
    }
  }
}

#bar1 {
  width: 722px;
  height: 410px;
}

#map {
  width: 950px;
  height: 904px;
}

#bar2 {
  width: 750px;
  height: 410px;
}

#pie1,
#pie2,
#pie3,
#pie4 {
  width: 734px;
  height: 540px;
}
.map-box {
  flex: 1;
  height: 1084px;
}
</style>